import { SHOW_MENA_BANNER, DISMISS_MENA_BANNER } from "./constants";

export { isMenaBannerVisible } from "./selectors";

const initialState = {
  visible: false,
  countryCode: null
};

export const reduce = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MENA_BANNER:
      return {
        ...state,
        visible: true,
        countryCode: action.payload.countryCode
      };
    case DISMISS_MENA_BANNER:
      return {
        ...state,
        visible: false
      };
    default:
      return state;
  }
};
